
import classNames from 'classnames';

import type { ReviewPeriod, ReviewTypeFilter } from '@api';
import { REVIEW_PERIOD, REVIEW_TYPE_FILTER } from '@api';

import DropdownSelect from '@store:web/components/common/DropdownSelect/DropdownSelect';

const reviewTypeOptions = [
  {
    value: REVIEW_TYPE_FILTER.ALL,
    label: 'Type (All)',
  },
  {
    value: REVIEW_TYPE_FILTER.TRUST_REVIEW,
    label: 'Trust Reviews',
  },
  {
    value: REVIEW_TYPE_FILTER.REVIEW,
    label: 'User Reviews',
  },
  {
    value: REVIEW_TYPE_FILTER.SUGGESTION,
    label: 'Suggestions',
  },
];

const reviewPeriodOptions = [
  {
    value: REVIEW_PERIOD.ALL,
    label: 'Period (All)',
  },
  {
    value: REVIEW_PERIOD.LAST_30_DAYS,
    label: 'Last 30 days',
  },
  {
    value: REVIEW_PERIOD.LAST_3_MONTHS,
    label: 'Last 3 months',
  },
  {
    value: REVIEW_PERIOD.LAST_6_MONTHS,
    label: 'Last 6 months',
  },
  {
    value: REVIEW_PERIOD.LAST_12_MONTHS,
    label: 'Last 12 months',
  },
];

interface UserReviewsFiltersProps {
  type: ReviewTypeFilter;
  period: ReviewPeriod;
  onTypeChange: (value: ReviewTypeFilter) => void;
  onPeriodChange: (value: ReviewPeriod) => void;
  className?: string;
}

const UserReviewsFilters = ({
  className,
  type,
  period,
  onTypeChange,
  onPeriodChange,
}: UserReviewsFiltersProps) => {
  return (
    <div className={classNames('flex items-center flex-wrap gap-4', className)}>
      <DropdownSelect options={reviewTypeOptions} value={type} onValueChange={onTypeChange} />

      <DropdownSelect options={reviewPeriodOptions} value={period} onValueChange={onPeriodChange} />
    </div>
  );
};

export default UserReviewsFilters;
